import {NgClass}                            from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {RouterLink, RouterLinkActive}       from '@angular/router';
import {IconName}                           from '@fortawesome/fontawesome-common-types';

export interface StatusItemIntf {
	uuid: string;
	icon?: IconName;
	text: string | null

}

@Component({
			   selector   : 'app-ui-status-item',
			   imports: [
				   NgClass,
				   RouterLink,
				   RouterLinkActive
			   ],
			   templateUrl: './ui-status-item.component.html',
			   styleUrl   : './ui-status-item.component.css'
		   })
export class UiStatusItemComponent {
	statusItem = input.required<StatusItemIntf>()
	itemPath = input<string>()
	reverseIcon = input(false, {transform: booleanAttribute});
}
